export default __webpack_public_path__ + "static/media/pdf-file-format-symbol-2.c1df41ab.png";